import { Dropzone as Dropzone$1 } from './Dropzone.mjs';
import { DropzoneFullScreen } from './DropzoneFullScreen.mjs';
export { DropzoneAccept, DropzoneIdle, DropzoneReject } from './DropzoneStatus.mjs';
export { EXE_MIME_TYPE, IMAGE_MIME_TYPE, MIME_TYPES, MS_EXCEL_MIME_TYPE, MS_POWERPOINT_MIME_TYPE, MS_WORD_MIME_TYPE, PDF_MIME_TYPE } from './mime-types.mjs';

Dropzone$1.FullScreen = DropzoneFullScreen;
const Dropzone = Dropzone$1;

export { Dropzone, DropzoneFullScreen };
//# sourceMappingURL=index.mjs.map
